import ApiService, { errorMessage } from "helpers/ApiHelper";

// Singular `translation` — the CMS translation helper, not `/translations`,
// which is the unrelated per-user profile translations endpoint.
const ROOT = "/api/v1/translation/glossary";

export { errorMessage };

/**
 * The term pairs and the DeepL sync state in one response, because the state
 * only means anything next to the list it was built from.
 */
export const fetchGlossary = () => ApiService.request(ROOT, "get");

export const createTerm = (term) => ApiService.request(ROOT, "post", term);

/**
 * PATCH is partial on this endpoint, but this screen always sends both fields:
 * the form holds the whole pair, and a partial send would make an edit that
 * blanks a side indistinguishable from one that leaves it alone.
 */
export const updateTerm = (id, term) => ApiService.request(`${ROOT}/${id}`, "patch", term);

export const deleteTerm = (id) => ApiService.request(`${ROOT}/${id}`, "delete");

/**
 * Rebuild the DeepL glossary now.
 *
 * Needed because the automatic sync on every write is allowed to fail quietly —
 * without this the only way to retry would be to edit a term at random.
 */
export const resyncGlossary = () => ApiService.request(`${ROOT}/sync`, "post");
